/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Saving_Project_ToastInputs */



/**
* | output |
* | --- |
* | "Saving project locally..." |
*
* @param {Shortcut_Keys_Saving_Project_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_saving_project_toast = /** @type {((inputs?: Shortcut_Keys_Saving_Project_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Saving_Project_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrement du projet en local...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt vor Ort sparen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Salvataggio del progetto in locale...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сохранение проекта на местном уровне...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guardando proyecto localmente...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目保存到本地……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトをローカルに保存しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थानीय स्तर पर बचत परियोजना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Salvando projetos localmente...")
	return /** @type {LocalizedString} */ ("Saving project locally...")
});